import React from 'react';

import Toolbar from './Toolbar';
import MenuItem from 'material-ui/MenuItem';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

const Header = ({ title = 'C-TMS', ...props }) => (
    <Toolbar
        title={title}
        actions={
            <MenuItem
                primaryText="Sign out"
                leftIcon={<CancelIcon />}
                href='/logout'
            />
        }
        {...props}
    />
);

export default Header;
